import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EmpleadosYucatanGuard implements CanActivate {
  rid: string;
    roloptions: any[] = [];
    p = false;
    constructor(
      public router: Router
    ) {}
      canActivate() {
      this.roloptions = JSON.parse(localStorage.getItem('data'));
      if ( this.roloptions.includes(btoa('Empleados gobierno')) ) {
        return true
      } else {
        this.router.navigate(['/home']);
        return false;
      }
      
      
    }
  }
